"use client";

import { motion } from "framer-motion";
import Link from "next/link";

export default function BenefitsSection({ benefits = [] }) {
  return (
    <section className="w-full py-14 sm:py-16 lg:py-20 xl:py-14 2xl:py-28 px-4 sm:px-6 lg:px-14 bg-[#FAFAFA]">

      {/* 🔥 SUPER CONTAINER (BIG SCREEN FIX) */}
      <div className="w-full mx-auto 
        max-w-[1300px] 
        lg:max-w-[1500px] 
        xl:max-w-[1700px] 
        2xl:max-w-[2000px] 
        3xl:max-w-[2200px]">

        {/* HEADER */}
        <div className="text-center mb-14 sm:mb-16 lg:mb-20 xl:mb-24 max-w-5xl mx-auto">

          <p className="text-xs sm:text-sm lg:text-base font-semibold tracking-[0.15em] uppercase text-[#B8893A] mb-3 sm:mb-4">
            Why Free Zone?
          </p>

          <h2 className="font-bold text-[#0A0A0A] leading-tight mb-4 sm:mb-5
            text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-[3rem] 2xl:text-[3.4rem] 3xl:text-[3.8rem]">
            Advantages of Setting Up in a Free Zone
          </h2>

          <p className="text-gray-500 leading-relaxed
            text-sm sm:text-base lg:text-lg xl:text-xl 2xl:text-xl">
            What are the main benefits to starting your company in a free zone?
          </p>
        </div>

        {/* GRID */}
        <div className="grid 
          grid-cols-1 
          sm:grid-cols-2 
          lg:grid-cols-3 
          xl:grid-cols-4 
          2xl:grid-cols-4 
          3xl:grid-cols-4 
          gap-5 sm:gap-6 lg:gap-7 xl:gap-5">

          {benefits.map((b, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: i * 0.1, ease: "easeOut" }}
              viewport={{ once: true }}
              className="h-full flex flex-col bg-[#fafafa] rounded-xl sm:rounded-[16px] 
                         p-5 sm:p-6 lg:p-7 
                         border border-gray-200 
                         shadow-sm hover:shadow-md
                         hover:border-[#B8893A]/20 transition-all duration-200"
            >

              {/* IMAGE */}
              {/* {b.image && (
                <div className="w-full h-[180px] sm:h-[200px] lg:h-[200px] rounded-lg overflow-hidden mb-4 sm:mb-5">
                  <img
                    src={b.image}
                    alt={b.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              )} */}

              {/* BADGE */}
              {b.badge && (
                <div className="inline-flex items-center gap-2 bg-[#FDF6EC] text-[#854F0B]
                                text-xs sm:text-sm font-semibold tracking-wide uppercase 
                                rounded-full px-3 py-2 mb-3 sm:mb-2 w-max">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#B8893A]" />
                  {b.badge}
                </div>
              )}

              {/* TITLE */}
              <h3 className="font-semibold text-[#0A0A0A] leading-tight mb-3
                text-base sm:text-lg lg:text-xl xl:text-xl 2xl:text-2xl">
                {b.title}
              </h3>

              {/* DIVIDER */}
              <div className="h-px bg-gray-200 mb-3" />

              {/* DESC */}
              <p className="text-gray-600 leading-relaxed mb-auto
                text-sm sm:text-base lg:text-base xl:text-md">
                {b.description}
              </p>

              {/* FOOTER */}
              <div className="h-px bg-gray-200 mt-4 mb-3" />
              {/* <Link href="/services" className="text-xs sm:text-sm lg:text-base text-[#B8893A] font-semibold flex items-center gap-1 hover:gap-2 transition-all">
                Learn more <span>→</span>
              </Link> */}

            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
